export interface YClipObjectTypes {
    'ui-color': string;
    'ui-font': number;
}

export type YClipObjectType = keyof YClipObjectTypes;
export type YClipObject = { [K in YClipObjectType]: [K, YClipObjectTypes[K]] }[YClipObjectType];

export namespace $clip {
    export function writeObject<K extends YClipObjectType>(kind: K, object: YClipObjectTypes[K]) {
        return navigator.clipboard.writeText(JSON.stringify({ kind, object }, undefined, 2));
    }

    export async function readObject(): Promise<YClipObject | null> {
        const text = await navigator.clipboard.readText();
        try {
            const { kind, object } = JSON.parse(text);
            if(typeof kind === 'string')
                return [kind as YClipObjectType, object];
        } catch(e) {}

        return null;
    }
}
